import { FC } from 'react';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { useAtomValue } from 'jotai';

const EventJsonLd: FC = () => {
  const { region } = useAtomValue($Locale);

  const JSONLD = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: '100 Bucket List Ideas',
    startDate: '2023-12-8T12:00:00-08:00',
    endDate: '2023-12-28T12:00:00-08:00',
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    location: {
      '@type': 'VirtualLocation',
      url: `https://www.lemon8-app.com/activity/100-things?region=${region}`,
    },
    image: [],
    description: '', // TODO: add 100 Bucket List Ideas description
    performer: {
      '@type': 'Person',
      name: 'yourself',
    },
    organizer: {
      '@type': 'Organization',
      name: 'Lemon8',
      url: 'https://www.lemon8-app.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://p16-va.lemon8cdn.com/tos-maliva-p-0000/53cd12e93fe546d699c01684bb0c9930~tplv-tej9nj120t-scaling:512:0:q75.jpeg',
      },
    },
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(JSONLD) }}></script>;
};

export default EventJsonLd;
